import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 1"
      portada="https://fullcomics18.org/img6/touchuukasou1-1.jpg"
     paginas={[
          "https://fullcomics18.org/img6/touchuukasou1-1.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-2.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-3.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-4.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-5.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-6.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-7.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-8.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-9.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-10.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-11.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-12.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-13.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-14.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-15.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-16.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-17.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-18.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-19.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-20.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-21.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-22.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-23.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-24.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-25.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-26.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-27.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-28.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-29.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-30.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-31.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-32.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-33.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-34.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-35.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-36.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-37.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-38.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-39.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-40.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-41.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-42.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-43.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-44.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-45.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-46.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-47.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-48.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-49.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-50.jpg",
  "https://fullcomics18.org/img6/touchuukasou1-51.jpg"
]}
      sugeridos={[]}


      info={{
        grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Big Ass", "Big Breasts", "Blackmail", "Condom", "Digital Fingering", "Freckles", "Kissing", "Multi-work Series", "Muscle", "Nakadashi", "Netorare", "Paizuri", "Shaved Head", "Sole Female", "Sole Male", "Sweating", "X-Ray"],
        artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 1",
  portada: "https://fullcomics18.org/img6/touchuukasou1-1.jpg",
  reverso: "https://fullcomics18.org/img6/touchuukasou1-47.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Big Ass", "Big Breasts", "Blackmail", "Condom", "Digital Fingering", "Freckles", "Kissing", "Multi-work Series", "Muscle", "Nakadashi", "Netorare", "Paizuri", "Shaved Head", "Sole Female", "Sole Male", "Sweating", "X-Ray"],
    artistas: "Fuetakishi",
  },
};
